import { DEFAULT_TEACHER_RATES } from '../../../LambdaFunctions/shared/teacherRateDefaults';

export { DEFAULT_TEACHER_RATES };

export const TEACHER_RATE_TIERS = Object.freeze([1, 2, 3, 4, 5, 6]);
export const TEACHER_RATE_DURATIONS = Object.freeze([45, 60]);

export function normalizeStudentCount(count) {
  const parsed = parseInt(count, 10);
  if (Number.isNaN(parsed) || parsed < 1) return 1;
  if (parsed >= 6) return 6;
  return parsed;
}

export function normalizeDuration(duration) {
  const parsed = parseInt(duration, 10);
  if (parsed === 60) return 60;
  return 45;
}

export function getTeacherLessonRate(teacherOrRates, studentCount = 1, durationMinutes = 45) {
  const countKey = normalizeStudentCount(studentCount);
  const durationKey = normalizeDuration(durationMinutes);

  const rates = (teacherOrRates && typeof teacherOrRates === "object")
    ? (teacherOrRates.rates || teacherOrRates.wageRates || teacherOrRates.teacherRates || teacherOrRates.teacherExtensions?.rates || teacherOrRates.extensions?.rates || teacherOrRates)
    : null;

  if (rates && typeof rates === "object") {
    // Check rates[countKey][durationKey]
    if (rates[countKey] && rates[countKey][durationKey] !== undefined) {
      const rate = Number(rates[countKey][durationKey]);
      if (!Number.isNaN(rate) && rate >= 0) return rate;
    }
    // Check inverted rates[durationKey][countKey]
    if (rates[durationKey] && rates[durationKey][countKey] !== undefined) {
      const rate = Number(rates[durationKey][countKey]);
      if (!Number.isNaN(rate) && rate >= 0) return rate;
    }
  }

  return DEFAULT_TEACHER_RATES[countKey][durationKey];
}

export function updateTeacherRate(currentRates, studentCount, durationMinutes, newRate) {
  const countKey = normalizeStudentCount(studentCount);
  const durationKey = normalizeDuration(durationMinutes);
  const parsed = Number(newRate);
  const numericRate = Math.max(0, Number.isNaN(parsed) ? 0 : parsed);

  const baseRates = currentRates && typeof currentRates === "object" ? currentRates : {};
  const currentTier = baseRates[countKey] || DEFAULT_TEACHER_RATES[countKey];

  return {
    ...baseRates,
    [countKey]: {
      ...currentTier,
      [durationKey]: numericRate,
    },
  };
}
